module.exports = "<div class=input-field> <icon v-if=icon class=prefix :value=icon></icon> <input v-el:input type=date class=datepicker :id=id :disabled=disabled> <label :for=id class=date-picker-active-label>{{label}}<slot></slot></label> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/forms/date-picker.vue
 ** module id = 306
 ** module chunks = 0
 **/